import React from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { swalSuccess } from '../../../common/components/Swaler'
import { removeLockAccesses } from '../../../common/redux/collectionActions'
import '../../Lock/css/lock.css'

const UserLock = ({ customer, t, lock, access, isContactPerson }) => {
  const dispatch = useDispatch()

  const removeAccess = () => {
    const username = customer.name ? `${customer.name} ${customer.surname ? customer.surname : ''}` : `${customer.phone}`

    const html = `<p>${t('Removed {username} from {door}', { username, door: lock.custom_name })}</p>`

    dispatch(removeLockAccesses([`${access._id}${lock.isCarrierDoor ? '-carrierDoor' : ''}`]))
    swalSuccess(t('Access removed'), null, t('OK'), html)
  }

  let door_type
  switch (lock.type) {
    case 'box':
      door_type = t('Delivery box')
      break
    case 'room':
      door_type = t('Delivery room')
      break
    case 'cluster':
      door_type = t('Cluster')
      break
    case 'passage':
      door_type = t('Passage')
      break
    default:
      break
  }

  if (lock.sub_type) {
    switch (lock.sub_type) {
      case 'container':
        door_type = t('Container')
        break
      default:
        break
    }
  }

  return (
    <Grid className="component-width">
      <Row key={lock._id}>
        <li style={{ width: '100%', borderTop: '1px solid lightgrey', paddingBottom: '10px' }} className="lock-flex-container2">
          <Col xs={4} md={2}>
            <div style={{ paddingTop: '10px' }} className="lock-label">
              {lock.custom_name ? lock.custom_name : door_type}
            </div>
          </Col>
          <Col xs={4} md={8} style={{ paddingTop: '10px', color: 'rgb(83, 83, 83)' }}>
            {lock.address && lock.address.street ? lock.address.street : t('Address missing')}
          </Col>

          <Col xs={0} md={2} style={{ paddingTop: '10px', paddingRight: '40px', textAlign: 'right' }} className="remove-user-door">
            {isContactPerson ? (
              ''
            ) : (
              <span onClick={removeAccess} style={{ cursor: 'pointer' }}>
                {t('Remove')}
              </span>
            )}
          </Col>
        </li>
      </Row>
    </Grid>
  )
}

export default UserLock
